const { getNewAccessToken } = require('./refreshToken');  
  
function parseCookies(cookieString) {  
    const cookies = {};  
    cookieString.split(';').forEach(cookie => {  
        const [name, value] = cookie.split('=').map(c => c.trim());  
        cookies[name] = value;  
    });  
    return cookies;  
}  
  
const fetchWithRetry = async (url, options = {}, retry = true) => {  
    try {  
        options.headers = options.headers || {};  
        options.credentials = 'include';  
  
        let response = await fetch(url, options);  
  
        if (response.status === 401 && retry) {  
            const { refreshToken } = parseCookies(document.cookie);  
            await getNewAccessToken(refreshToken);  
  
            return await fetchWithRetry(url, options, false);  
        }  
  
        return response;  
    } catch (error) {  
        console.error('Fetch with retry failed:', error);  
        throw error;  
    }  
};  
  
module.exports = { parseCookies, fetchWithRetry };  